import React from 'react';
import { ThemeProvider } from 'styled-components';
import ModernLayout from './src/components/ModernLayout';
import theme from './src/utils/theme';

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>
    <ModernLayout>{element}</ModernLayout>
  </ThemeProvider>
);
